<script setup lang="ts">

import { useRoute } from "vue-router";
import { HowItWorks, LinkCardPromotionTile } from ".";
import { ProfileHeader } from "../Components";
import { AddBankAccountPromotionTile } from "../Promotion";
import type { ICarbucksProfile } from "@domain/Carbucks";
import { useAppConfiguration } from "@domain/AppConfiguration";

const model = defineModel<ICarbucksProfile>( { required: true } );
const emit = defineEmits( [ 'dismiss-promotion' ] );

const app = useAppConfiguration();
const route = useRoute();
const isMarketplace = route.path == '/my-marketplace';

</script>

<template>

    <div class="tracking-wider">

        <div class="bg-gradient-to-b dark:from-gray-900 dark:to-gray-800">
        
            <ProfileHeader v-model="model" 
                           :is-marketplace="isMarketplace"
                           @dismiss-promotion="emit( 'dismiss-promotion' )" />

            <HowItWorks class="mt-6" />

        </div>

        <div class="bg-gradient-to-b dark:from-gray-800 dark:via-50% dark:via-gray-800 dark:to-gray-850 h-8">
        </div>

        <LinkCardPromotionTile v-model="model" :canDismiss="false" />

        <!-- ONLY SHOW BANK ACCOUNT LINK TO USERS THAT ARE NOT CONNECTED TO A DEALERSHIP -->
        <div v-if="app.isGeneric">
            <AddBankAccountPromotionTile v-model="model" />
        </div>

        <div v-else
             class="bg-gradient-to-b dark:from-gray-800 dark:to-gray-900 
                    text-base 3xl:text-lg">

            <div class="bg-gradient-to-t from-transparent via-50% via-gray-800 to-gray-850 h-8">
            </div>

            <div class="flex flex-col gap-2 px-4 lg:px-6 3xl:px-8 -mt-3">
                <p class="text-justify">
                    Cashback rewards are collected in your account to help cover your
                    maintenance expenses with your Home Dealership.
                </p>

                <p class="text-justify">
                    So collect your rewards and use them to lower the cost of maintaining your car.
                </p>
            </div>

        </div>

    </div>

</template>